import { ForgeProjectFigmaNode, ForgeProjectFigmaNodeRenderInput, } from "@supernova-studio/model";
export const DTOForgeProjectFigmaNode = ForgeProjectFigmaNode;
export const DTOForgeProjectFigmaNodeRenderInput = ForgeProjectFigmaNodeRenderInput;
